import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import TimelineIcon from "@mui/icons-material/Timeline";
import { Button, IconButton, Switch, Tooltip, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSuperAdminSinglePlan } from "../../../context/SuperAdmin/SinglePlanContext";
import { useAuthContext } from "../../../hooks/Auth";
import { Estado } from "../../../interfaces/SuperAdmin/Others/iDataEstado";
import {
  iDataSuscripcionOrg,
  PutSuscriptFields,
} from "../../../interfaces/SuperAdmin/Pages/iDataSuscripcion";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../ui-components/StyledTables";
import { esFechaFutura, formatFecha, formatFechaWithHour } from "../../../utils/dateFunctions";

interface Props {
  suscription: iDataSuscripcionOrg;
  i: number;
}

const ProfileRowSucript: FC<Props> = ({ suscription, i }) => {
  const {
    organizacion,
    fecha_inicio,
    fecha_fin,
    id_suscripcion,
    created_at,
    estado,
  } = suscription;

  const [isActive, setIsActive] = useState(estado === Estado.ACTIVO);
  const { assignToDeleteSuscr, handleEdit, editSuscription } =
    useSuperAdminSinglePlan();

  const { user } = useAuthContext();

  //Apenas se monte el componente, se evaluará si la suscripción está activa o no
  useEffect(() => {
    setIsActive(estado === Estado.ACTIVO);
  }, [suscription]);

  // Función para cambiar el estado de una suscripción
  const toggleActive = async () => {
    const body = { estado: isActive ? Estado.INACTIVO : Estado.ACTIVO };
    editSuscription(id_suscripcion, body as PutSuscriptFields);
  };

  const canChangeDate = esFechaFutura(fecha_inicio);

  return (
    <StyledTableRow sx={{ opacity: estado === Estado.VENCIDO ? 0.5 : 1 }}>
      <StyledTableCell sx={{ mb: 2 }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 2 }}>{organizacion}</StyledTableCell>
      <StyledTableCell>{formatFechaWithHour(created_at)}</StyledTableCell>
      <StyledTableCell>{formatFecha(fecha_inicio)}</StyledTableCell>
      <StyledTableCell>{formatFecha(fecha_fin)}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {estado !== Estado.VENCIDO ? (
          <Tooltip
            title={
              esFechaFutura(fecha_inicio)
                ? "No se puede activar una suscripción que aún no ha empezado"
                : ""
            }
            arrow
          >
            <span>
              <Switch
                checked={isActive}
                onChange={toggleActive}
                disabled={esFechaFutura(fecha_inicio)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#2E7D32",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#2E7D32",
                  },
                }}
              />
            </span>
          </Tooltip>
        ) : (
          <Typography>{estado}</Typography>
        )}
      </StyledTableCell>
      <StyledTableCell align="center">
        <Button
          sx={{ color: "#336B87", opacity: canChangeDate ? 1 : 0.5 }}
          disabled={!canChangeDate}
          onClick={() => handleEdit(suscription)}
        >
          <Tooltip title="Cambiar fecha de inicio">
            <IconButton sx={{ color: "#336B87" }}>
              <DateRangeOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => assignToDeleteSuscr(suscription.id_suscripcion)}
        >
          <Tooltip title="Eliminar suscripción">
            <IconButton aria-label="delete" sx={{ color: "#336B87" }}>
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>
        <Link
          to={`/asistente/suscriptions/${user?.id_organizacion}/${suscription.id_suscripcion}`}
        >
          <Button sx={{ color: "#336B87" }}>
            <Tooltip title="Gestionar usuarios">
              <IconButton aria-label="usuarios" sx={{ color: "#336B87" }}>
                <PeopleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Button>
        </Link>
        <Link
          to={`/asistente/suscriptions/${user?.id_organizacion}/${suscription.id_suscripcion}/credits`}
        >
          <Button sx={{ color: "#336B87" }}>
            <Tooltip title="Uso de créditos">
              <IconButton aria-label="créditos" sx={{ color: "#336B87" }}>
                <TimelineIcon />
              </IconButton>
            </Tooltip>
          </Button>
        </Link>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default ProfileRowSucript;
